import type { MouseEvent, RefObject } from 'react';
import { faPenToSquare } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { Icon } from '@/components/ui/icon';
import { FloatingBlockToolbarPortal } from './floating-block-toolbar-portal';

const FIELD_EDIT_TOOLBAR_CLASS =
  'cursor-default overflow-hidden rounded-md border border-primary/20 bg-background font-medium shadow-lg';

export function FieldEditToolbar({
  anchorRef,
  label,
  onEdit,
  ariaLabel,
}: {
  anchorRef: RefObject<HTMLElement | null>;
  label: string;
  onEdit: (event?: MouseEvent) => void;
  ariaLabel?: string;
}) {
  return (
    <FloatingBlockToolbarPortal anchorRef={anchorRef}>
      <div className="pointer-events-auto flex items-center" data-slot-inside>
        <ButtonGroup
          role="toolbar"
          aria-label={ariaLabel ?? `${label} actions`}
          data-block-action-toolbar
          className={FIELD_EDIT_TOOLBAR_CLASS}
        >
          <Button
            variant="ghost"
            size="sm"
            onPointerDown={(event) => event.stopPropagation()}
            onMouseDown={(event) => event.preventDefault()}
            onClick={(event) => {
              event.stopPropagation();
              onEdit(event);
            }}
          >
            <Icon icon={faPenToSquare} />
            {label}
          </Button>
        </ButtonGroup>
      </div>
    </FloatingBlockToolbarPortal>
  );
}
